export default __webpack_public_path__ + "static/media/Workbench.256.3c11c58a.png";